import React from 'react';
import styled from 'styled-components';
const IconDiv = styled.div.withConfig({
  displayName: "VisitHeaderIcon__IconDiv",
  componentId: "vohf3n-0"
})(["", " ", " width:20px;height:20px;cursor:pointer;padding:1px;border-radius:10px;display:flex;flex-direction:row;align-items:center;align-content:center;justify-content:center;font-family:'Muli',sans-serif;font-size:1rem;font-weight:600;line-height:1;"], props => `background-color: ${props.color || '#880808'};`, props => `color: ${props.theme.palette.common.white};`);
export const VisitHeaderIcon = ({
  displayValue,
  onClick,
  color,
  id
}) => /*#__PURE__*/React.createElement(IconDiv, {
  id: id,
  color: color,
  onClick: onClick
}, displayValue);